var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonsterOvals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "72px",
    viewBox: "0 0 56 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Platforma_ALL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ALL---2---Dashboard",
    transform: "translate(-347.000000, -4120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(347.000000, 4121.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4875,64.5429 C42.3905,65.1809 42.9805,66.2329 42.9805,67.4239 C42.9805,67.7759 42.9275,68.1159 42.8315,68.4389 C42.5425,69.4069 41.8475,70.2009 40.9445,70.6219 C40.6485,70.7629 40.3285,70.8609 39.9925,70.9109 C39.8175,70.9389 39.6375,70.9529 39.4535,70.9529 C37.5045,70.9529 35.9245,69.3719 35.9245,67.4239 C35.9245,65.9749 36.7995,64.7299 38.0485,64.1879 C38.4655,64.0059 38.9245,63.9029 39.4075,63.8979 C39.4235,63.8969 39.4375,63.8969 39.4535,63.8969 C40.2125,63.8969 40.9135,64.1349 41.4875,64.5429",
    id: "Fill-30",
    fill: "#85A1F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.302,4.5292 C32.555,1.8682 27.978,0.3092 23.029,0.3092 C22.929,0.3092 22.828,0.3092 22.729,0.3232 C19.581,0.3522 16.577,1.0242 13.86,2.2122 C5.707,5.7452 5.32907052e-14,13.8692 5.32907052e-14,23.3242 C5.32907052e-14,36.0402 10.313,46.3522 23.029,46.3522 C24.23,46.3522 25.403,46.2662 26.547,46.0812 C28.736,45.7522 30.824,45.1082 32.755,44.1932 C38.648,41.4462 43.182,36.2682 45.071,29.9462 C45.699,27.8432 46.043,25.6272 46.043,23.3242 C46.043,15.5572 42.196,8.6912 36.302,4.5292",
    id: "Fill-36",
    fill: "#FFF6E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4367,11.456 C54.4367,17.783 49.3077,22.912 42.9807,22.912 C36.6537,22.912 31.5247,17.783 31.5247,11.456 C31.5247,5.129 36.6537,1.15463195e-13 42.9807,1.15463195e-13 C49.3077,1.15463195e-13 54.4367,5.129 54.4367,11.456 Z",
    id: "Stroke-63",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonsterOvals);
export default __webpack_public_path__ + "static/media/monsterOvals.79ba8b023b2db5d56c537401b2cb9137.svg";
export { ForwardRef as ReactComponent };